const hostname = window.location.hostname.toLowerCase();
const previewMode = import.meta.env.DEV ? new URLSearchParams(window.location.search).get("pwa") : null;

export function getPwaMode() {
  if (["global", "campo", "cliente"].includes(previewMode)) return previewMode;
  if (hostname === "campo.welltech.net.br" || hostname.startsWith("campo.")) return "campo";
  if (hostname === "cliente.welltech.net.br" || hostname.startsWith("cliente.")) return "cliente";
  return "global";
}

export const pwaCatalog = {
  global: {
    name: "WellTech Global",
    manifest: "/manifest-global.webmanifest",
    serviceWorker: "/sw-global.js",
    home: "/dashboard",
    installLabel: "WellTech Global"
  },
  campo: {
    name: "WellTech Campo",
    manifest: "/manifest-campo.webmanifest",
    serviceWorker: "/sw-campo.js",
    home: "/tecnico",
    installLabel: "WellTech Campo"
  },
  cliente: {
    name: "WellTech Cliente",
    manifest: "/manifest-cliente.webmanifest",
    serviceWorker: "/sw-cliente.js",
    home: "/cliente",
    installLabel: "WellTech Cliente"
  }
};

export function getPwaConfig() {
  return pwaCatalog[getPwaMode()];
}
